export function isType(action) {
    var creators = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        creators[_i - 1] = arguments[_i];
    }
    return creators.some(function (_a) {
        var type = _a.type;
        return action.type === type;
    });
}
